import {Item} from '../../models/Item';
import {AbstractMainPlugin} from '../AbstractMainPlugin';


export class InjectAttributesPlugin extends AbstractMainPlugin {

  constructor(item: Item) {
    super(item);

    this.initListeners();
  }

  private initListeners() {
    const attributes = ['visibility', 'clickable'];
    attributes.forEach(attribute => {
      const input = this.item.config.getInputByName(attribute);
      if (!input && this.item.config.getTool().params && this.item.config.getTool().params.hasOwnProperty(attribute)) {
        this.item.config.assignInput(attribute, this.item.config.getTool().params[attribute]);
      }
    });
  }

}
